module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicki Bennett, Ariel Tachna\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Growing up in Chicago, Nicki Bennett spent every Saturday at the central library, losing herself in the world of books. A voracious reader, she eventually found it difficult to find enough of the kind of stories she liked to read and decided to start writing them herself.")]), _c('P', [_vm._v("Facebook: www.facebook.com/100011754789784")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ppdjkc/tc-custom/9781641086714.jpg?1711126045671",
      "alt": "This image is the cover for the book Rocky Road to Love"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rocky Road to Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v(" When Mason gets caught in a blizzard on his way home for Christmas and ends up in a snowdrift, the outlook is grim—until a handsome trucker appears, offering shelter, companionship, and a tow in the morning. ")]), _c('p', [_vm._v(" Tate has never been anyone’s idea of a hero. He’s been on the road most of his adult life, with few ties to people and even fewer to any particular place. Now, after one steamy night in the cab of his truck, all that changes. Suddenly he has a sweet, intelligent guy who can’t get enough of him, who invites him to spend New Year’s with his family… who already feels like home. But Tate’s job keeps him on the road for weeks at a time. Can he really build something permanent? ")]), _c('br'), _vm._v(" Portions of this novella appeared in the short stories"), _c('i', [_vm._v(" Weathering the Storm, Coming Home, ")]), _vm._v("and "), _c('i', [_vm._v("Tying the Knot,")]), _vm._v(" published by Dreamspinner Press in 2009. \n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Dreamspinner Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0